import { render, staticRenderFns } from "./arcocIntervencionista.vue?vue&type=template&id=b2477050&scoped=true&"
import script from "./arcocIntervencionista.vue?vue&type=script&lang=js&"
export * from "./arcocIntervencionista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2477050",
  null
  
)

export default component.exports